function getBaseSelector() {
  let baseSelector = "";
  if ($("#t4s-product-quick-view").length > 0) {
    baseSelector = "#t4s-product-quick-view ";
  }
  return baseSelector;
}

function highlightErrorSizeSelected() {
  let baseSelector = getBaseSelector();

  const btnSelector = `${baseSelector}button[data-atc-form]`;

  jQuery(document).on("click", btnSelector, function () {
    const btn = jQuery(this);

    const variantContainer = btn.closest(".t4s-product-form__variants");

    const sizeContainer = variantContainer.find(
      '[data-id="1"] .t4s-swatch__list'
    );
    const errorSizeMsg = variantContainer.find(".size-error-validation");

    const isSelected = sizeContainer.find(".is--selected").length > 0;
    if (!isSelected) {
      sizeContainer.addClass("highlight-error-size-selected");
      errorSizeMsg.css({ display: "block" }); // Mostrar mensaje de error
    } else {
      sizeContainer.removeClass("highlight-error-size-selected");
      errorSizeMsg.css({ display: "none" }); // Ocultar el mensaje

      const noticeWrapperContainer = $("#t4s-notices__wrapper");
      noticeWrapperContainer.css("visibility", "visible");
    }
  });
}

function restartStyleOnErrorMsg() {
  let baseSelector = getBaseSelector();
  const errorSizeMsg = $(`${baseSelector} .size-error-validation`);

  const sizeSelected = $(
    `${baseSelector}[data-swatch-option][data-id="1"] .is--selected`
  );

  const noticeWrapperContainer = $("#t4s-notices__wrapper");

  const sizeContainer = sizeSelected.closest(".t4s-swatch__list");

  if (sizeContainer.length > 0) {
    sizeContainer.removeClass("highlight-error-size-selected");
    errorSizeMsg.css({ display: "none" });
    noticeWrapperContainer.css("visibility", "visible");
  }
}

function overrideFormatMoney() {
  if (T4SThemeSP?.Currency?.formatMoney) {
    const originalFormatMoney = T4SThemeSP.Currency.formatMoney;

    T4SThemeSP.Currency.formatMoney = function (amount, format) {
      let formatted = originalFormatMoney(amount, format);

      formatted = formatted.replace(/(\.00)(?=[^<]*($|<))/g, "");

      return formatted;
    };
  } else {
    console.warn("T4SThemeSP.Currency.formatMoney no está disponible todavía");
  }
}

$(window).on("load", function () {
  //hideUnavailableAndSoldSizesByDefault();
  overrideFormatMoney();
  updateSizeWhenNoSizeSelected();
  hideShowPromotionMessageWhenSwapBetweenColors();
});

function updatePricesWhenSwapBetweenColors(variantsInColorSelected) {
  let baseSelector = getBaseSelector();

  const colorSelected = $(
    `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
  );

  const current_price = T4SThemeSP.Currency.formatMoney(
    variantsInColorSelected[0][2]
  );
  const compare_at_price = T4SThemeSP.Currency.formatMoney(
    variantsInColorSelected[0][3]
  );

  const element_price_selector = $(colorSelected)
    .closest(".t4s-product__info-container")
    .find(".t4s-product-price")
    .first();

  // const element_price_selector = $(
  //   ".t4s-product__info-container .t4s-product-price"
  // );

  if (current_price != compare_at_price) {
    var html = `<del>
        ${compare_at_price}
        </del>
        <ins class="custom-prod-on-sale">
        ${current_price}
        </ins>`;

    element_price_selector.html(html);
  } else {
    element_price_selector.text(compare_at_price);
  }
}

// function hideShowPromotionMessageWhenSwapBetweenColors() {
//   let baseSelector = getBaseSelector();

//   let promoLabel = $(`${baseSelector} #code-global-block`);

//   let promoPercentageOffLabel = promoLabel.find(
//     ".ecom-elements__lightbox-button-text"
//   );

//   const colorSelected = $(
//     `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
//   );

//   //const promoPercentageOff = colorSelected.data("percentage-off");

//   let is_Promoted = colorSelected.data("promotion");

//   if (is_Promoted) {
//     //promoPercentageOffLabel.text(promoPercentageOff);
//     promoLabel.show();
//   } else {
//     promoLabel.hide();
//   }
// }

function hideShowPromotionMessageWhenSwapBetweenColors() {
  let baseSelector = getBaseSelector();

  let promoLabel = $(`${baseSelector} #code-global-block`);
  let promoLabelText = $(`${baseSelector} .promotional-info`);

  let promoPercentageOffLabel = promoLabel.find(
    ".ecom-elements__lightbox-button-text"
  );

  const colorSelected = $(
    `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
  );

  //const promoPercentageOff = colorSelected.data("percentage-off");

  let is_Promoted = colorSelected.data("promotion");

  if (is_Promoted == "isNotPromoted") {
    //promoPercentageOffLabel.text(promoPercentageOff);
    promoLabelText.show();
  } else {
    promoLabelText.hide();
  }
}

// function updateCustomBadgeWhenSwapBetweenColors(is_Promoted) {
//   let baseSelector = getBaseSelector();
//   let productFeatureSelector = `${baseSelector} [data-product-featured]`;
//   let productFeatureObj = $(productFeatureSelector).data("product-featured");

//   if (is_Promoted) {
//     productFeatureObj.customBadge = ["Private Sale"];
//     productFeatureObj.customBadgeHandle = ["private-sale"];
//   } else {
//     productFeatureObj.customBadge = null;
//     productFeatureObj.customBadgeHandle = null;
//   }

//   $(productFeatureSelector).attr(
//     "data-product-featured",
//     JSON.stringify(productFeatureObj)
//   );
// }

function updateSizeWhenNoSizeSelected() {
  let baseSelector = getBaseSelector();

  const colorSelected = $(
    `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
  ).data("value");

  const swatch_item_list = $(`${baseSelector}[data-id="1"] [data-swatch-item]`);

  let isOneSize =
    $(swatch_item_list[0]).data("value") == "One Size" &&
    swatch_item_list.length == 1;
  if (isOneSize) {
    $(swatch_item_list[0]).trigger("click");
  }

  const jsonVariants = $(`${baseSelector} .pr_variants_json`);
  if (!jsonVariants.length) return;

  const jsonVariantsObj = JSON.parse(jsonVariants.html());

  const variantsInColorSelected = jsonVariantsObj
    .filter((item) => item.option1 == colorSelected)
    .map((item) => [
      item.option2,
      item.available,
      item.price,
      item.compare_at_price,
    ]);

  //console.log("Variants in JSON from color selected:", variantsInColorSelected);

  updatePricesWhenSwapBetweenColors(variantsInColorSelected);

  swatch_item_list.each((_, swatch_item) => {
    const $swatch_item = $(swatch_item);
    const swatch_item_size = $swatch_item.data("value");

    $swatch_item.removeClass("is--unavailable is--soldout");

    const sizeMatch = variantsInColorSelected.find(
      (variant) => variant[0] == swatch_item_size
    );

    if (!sizeMatch) {
      $swatch_item.addClass("is--unavailable");
    } else if (!sizeMatch[1]) {
      $swatch_item.addClass("is--soldout");
    }
  });
}

function NewSwatchBenhaviorForSizeClick() {
  $(document).on("click", "[data-swatch-item]", function () {
    processColorAvailability();
    restartStyleOnErrorMsg();
  });
}

function processColorAvailability() {
  let baseSelector = getBaseSelector();

  const colorContainers = $(
    `${baseSelector}[data-swatch-option][data-id="0"]`
  ).find("[data-swatch-item]");

  const colorSelected = $(
    `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
  ).data("value");

  const sizeSelected = $(
    `${baseSelector}[data-swatch-option][data-id="1"] .is--selected`
  ).data("value");

  if (sizeSelected) {
    const jsonVariants = $(`${baseSelector} .pr_variants_json`);
    if (!jsonVariants.length) return;

    const jsonVariantsObj = JSON.parse(jsonVariants.html());

    colorContainers.each((_, item) => {
      const currentItemColor = $(item).data("value");
      updateSoldOutSizeClick(
        currentItemColor,
        sizeSelected,
        $(item),
        jsonVariantsObj
      );
    });
  } else {
    updateSizeWhenNoSizeSelected();
  }
}

function updateSoldOutSizeClick(
  currentItemColor,
  sizeSelected,
  currentElement,
  jsonVariantsObj
) {
  let availableFound = false;

  for (const variant of jsonVariantsObj) {
    if (
      variant.option1 === currentItemColor &&
      variant.option2 == sizeSelected
    ) {
      if (variant.available === true) {
        availableFound = true;
        break;
      }
    }
  }

  if (!availableFound) {
    currentElement.addClass("is--soldout");
  } else {
    currentElement.removeClass("is--soldout");
  }
}

// Size Chart Modal POPUP

document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.getElementById("pdp-size-chart-toggle");
  var modal = document.getElementById("size-chart-modal");
  var backdrop = document.getElementById("modal-backdrop");

  if (!backdrop) {
    return;
  }

  if (toggle) {
    toggle.addEventListener("click", function () {
      var isModalOpen = modal.style.display === "block";
      modal.style.display = isModalOpen ? "none" : "block";
      backdrop.style.display = isModalOpen ? "none" : "block";
    });
  }

  backdrop.addEventListener("click", function () {
    modal.style.display = "none";
    backdrop.style.display = "none";
  });
});

// Customer Support Dropdown in Header
// document
//   .querySelector(".support-dropbtn")
//   .addEventListener("click", function () {
//     var dropdownContent = document.querySelector(".support-dropdown-content");
//     if (dropdownContent.style.display === "block") {
//       dropdownContent.style.display = "none";
//     } else {
//       dropdownContent.style.display = "block";
//     }
//   });

// Close the dropdown if the user clicks outside of it
// window.onclick = function (event) {
//   if (!event.target.matches(".support-dropbtn")) {
//     var dropdowns = document.getElementsByClassName("support-dropdown-content");
//     for (var i = 0; i < dropdowns.length; i++) {
//       var openDropdown = dropdowns[i];
//       if (openDropdown.style.display === "block") {
//         openDropdown.style.display = "none";
//       }
//     }
//   }
// };

$(document).ready(function () {
  displaySecondImageOnHoverOnCollectionPage();
  showMore();
  updateVariantNameOnCollectionPageOnSwatchClickHover();

  replaceJsonOptionsOnPDP();
  clearanceDisclaimer();
  // selectSwatchOnClick();
  selectSwatchOnClickPDP();
  //T4SThemeSP._initProducts;
  FixCatalogsAddedToDwawerCart();
  deleteCatalogFromMiniCart();
  //HideSwatchOnMarkdownOnRegularParent();
  // promoMessage();
  handleSwatchClickOnQuickShop();
  highlightErrorSizeSelected();
  NewSwatchBenhaviorForSizeClick();
  //updateSizeWhenNoSizeSelected();
});

function selectSwatchOnClick() {
  var swatchItemElementSelected = $(".full-price, .markdown");
  swatchItemElementSelected.on("click", function () {
    swatchItemElementSelected.removeClass("is--selected");
  });
}

function selectSwatchOnClickPDP() {
  if (ShopifyAnalytics.meta.page.pageType == "product") {
    var swatchItemElement =
      "#MainContent .is-t4s-style__color .t4s-swatch__item";

    // let reload_event = performance.getEntriesByType("navigation")[0].type;
    // if (reload_event == "reload") {
    //   let swatchAutoSelected = $(
    //     ".is-t4s-style__color .t4s-swatch__item.is--selected"
    //   );

    //   setTimeout(function () {
    //     console.log(swatchAutoSelected);
    //     swatchAutoSelected.trigger("click");
    //   }, 500);
    // }

    $("body").on("click", swatchItemElement, function () {
      let product_url = $(this).data("product-url");
      history.replaceState(null, "", product_url);
      //renderGallerySectionOnPDP(product_url);
      hideShowPromotionMessageWhenSwapBetweenColors();
      renderFabricSectionOnPDP(product_url);
      renderAplusSectionOnPDP(product_url);
      updateProductTitleColor()
      renderProductRelatedSectionOnPDP(product_url);
      getProductToActivateBackInStock(this, product_url);
      getSizeOnCollectionSwatchHover(this, product_url);
      T4SThemeSP.RenderRefresh();
    });
  }
}

// function renderGallerySectionOnPDP(current_product_url) {
//   let section_id_selector = "shopify-section-template--img__refresh";
//   let section_id = section_id_selector.replace(/^shopify-section-/g, "");

//   $(`#${section_id_selector} .t4s-row.t4s-g-0`).addClass(
//     "custom-pdp-img-gallery fade-out"
//   );

//   //let section_url_to_fetch = `${window.location.origin}${current_product_url}?section_id=${section_id}`;
//   let section_url_to_fetch = `${window.location.origin}${current_product_url}?section_id=main-product`;

//   // console.log(
//   //   "URL TO FETCH on renderGallerySectionOnPDP ",
//   //   section_url_to_fetch
//   // );

//   fetchAndAttachSection(section_url_to_fetch, section_id_selector).then(
//     (data) => {
//       document.querySelector(`#${section_id_selector}`).innerHTML = data;

//       T4SThemeSP.initCarousel();
//       T4SThemeSP.Isotopet4s;
//       T4SThemeSP.Isotopet4s.init;
//       T4SThemeSP.Isotopet4s.initEach();
//       T4SThemeSP.Carousel._initCarouselNav;
//       T4SThemeSP.RenderRefresh();
//       history.replaceState(null, "", current_product_url);
//     }
//   );
// }

//**
// Delete in near future
//  */
// function renderProductRelatedSectionOnPDP(current_product_url) {
//   let related_id_selector = "shopify-section-template--related__refresh";
//   let related_section_id = related_id_selector.replace(
//     /^shopify-section-/g,
//     ""
//   );
//   let section_url_related_to_fetch = `${current_product_url}`;

//   fetchAndAttachSection(section_url_related_to_fetch, related_id_selector).then(
//     (data) => {
//       document.querySelector(`#${related_id_selector}`).innerHTML = data;
//       //T4SThemeSP.initCarousel();
//       T4SThemeSP.reinitProductGridItem();
//       T4SThemeSP.initCarousel();
//       T4SThemeSP.Isotopet4s;
//       T4SThemeSP.Isotopet4s.init;
//       T4SThemeSP.Isotopet4s.initEach();
//       T4SThemeSP.Carousel._initCarouselNav;
//       T4SThemeSP.RenderRefresh();
//     }
//   );
// }
// Until Here

function renderProductRelatedSectionOnPDP(current_product_url) {
  const related_id_selector = 'shopify-section-template--related__refresh';
  let $container = $(`#${related_id_selector}`);

  if (!$container.length) {
    $container = $('[class*="custom_liquid_cfajBD"]');
    console.warn(`Container new `);
    //return;
  }

  const section_id = $('section[id*="__main"]').attr('id');
  const section_id_to_fetch = section_id
    ? section_id.replace(/^shopify-section-/g, '')
    : 'main-product';

  const url_to_fetch = `${window.location.origin}${current_product_url}?section_id=${section_id_to_fetch}`;

  T4SThemeSP.getToFetchSection(null, 'text', url_to_fetch)
    .then((html) => {
      if (!html || html === 'NVT_94') {
        console.warn('No data received or invalid response');
        return;
      }

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(html, 'text/html');
      const relatedSection = htmlDoc.querySelector(`#${related_id_selector}`);

      if (!relatedSection) {
        console.warn('Related section not found in response');
        return;
      }

      const relatedSectionHTML = relatedSection.innerHTML;

      $container.html(relatedSectionHTML);

      if ($container.find('.t4s-product, .t4s-collection-carousel').length > 0) {
        T4SThemeSP.reinitProductGridItem();
      }

      if (typeof T4SThemeSP?.Reveal === 'function') {
        T4SThemeSP.Reveal();
      }

      if ($container.find('.flickityt4s').length > 0) {
        const flickityElement = $container.find('.flickityt4s')[0];

        if (flickityElement) {
          try {
            const $flickity = $(flickityElement);
            const existingInstance = $flickity.data('flickity');
            if (existingInstance && typeof existingInstance.destroy === 'function') {
              existingInstance.destroy();
            }
          } catch (e) {
            console.warn('Error destroying previous Flickity instance:', e);
          }

          try {
            flickityElement.flickityt4s = new T4SThemeSP.Carousel(flickityElement);
          } catch (e) {
            console.error('Error creating Flickity instance:', e);
          }

          // setTimeout(() => {
          //   $(flickityElement).flickityt4s('resize');
          // }, 150);
        }
      }

      // RenderRefresh al final (patrón del tema)
      // if (typeof T4SThemeSP?.RenderRefresh === 'function') {
      //   T4SThemeSP.RenderRefresh();
      // }
    })
    .catch((error) => {
      console.error('Error in renderProductRelatedSectionOnPDP:', error);
    });
}

function renderFabricSectionOnPDP(current_product_url) {
  let fabric_id_selector = $('[id*="custom_liquid_VeWRAY"]').attr("id");
  if (!fabric_id_selector) {
    return;
  }
  let fabric_section_id = fabric_id_selector.replace(/^shopify-section-/g, "");
  let section_url_fabric_to_fetch = `${window.location.origin}${current_product_url}?section_id=${fabric_section_id}`;

  T4SThemeSP.getToFetchSection(null, "text", section_url_fabric_to_fetch).then(
    (html) => {
      if (html) {
        document.querySelector(`#${fabric_id_selector}`).innerHTML = html;
      }
    }
  );
}

function renderAplusSectionOnPDP(current_product_url) {
  let aplus_id_selector = $('[id*="custom_liquid_fBNyAB"]').attr("id");
  if (!aplus_id_selector) {
    return;
  }
  let aplus_section_id = aplus_id_selector.replace(/^shopify-section-/g, "");
  let section_url_aplus_to_fetch = `${window.location.origin}${current_product_url}?section_id=${aplus_section_id}`;

  T4SThemeSP.getToFetchSection(null, "text", section_url_aplus_to_fetch).then(
    (html) => {
      if (html) {
        document.querySelector(`#${aplus_id_selector}`).innerHTML = html;
      }
    }
  );
}

function updateProductTitleColor() {
  let baseSelector = getBaseSelector();
  const colorTitleContainer = `${baseSelector} .t4s-product__title .color_title`;
  const swatchSelected = `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`;
  const colorTitle = $(swatchSelected).data("value");

  if (colorTitleContainer) {
    $(colorTitleContainer).text(" " + colorTitle);
  }
}

// function renderGallerySectionOnPDP(current_product_url) {
//   const section_id = $('section[id*="__main"]').attr("id");
//   const section_id_to_fetch = section_id.replace(/^shopify-section-/g, "");
//   const url_to_fetch = `${window.location.origin}${current_product_url}?section_id=${section_id_to_fetch}`;
//   const gallerySectionId = "#shopify-section-template--img__refresh";
//   const currentGalleryContainer = document.querySelector(gallerySectionId);
//   if (currentGalleryContainer) {
//     currentGalleryContainer.style.transition = "opacity 0.3s ease-out";
//     currentGalleryContainer.style.opacity = "0";
//   }

//   const color_title_selector = ".t4s-product__title .color_title";
//   const colorTitleContainer = document.querySelector(color_title_selector)

//   T4SThemeSP.getToFetchSection(null, "text", url_to_fetch).then((html) => {
//     if (html) {
//       const parser = new DOMParser();
//       const htmlDoc = parser.parseFromString(html, "text/html");
//       const newGallerySection = htmlDoc.querySelector(gallerySectionId);
//       const newColorSection= htmlDoc.querySelector(color_title_selector);

//       if(colorTitleContainer){
//         colorTitleContainer.innerHTML = newColorSection.innerHTML
//         currentGalleryContainer.innerHTML = newGallerySection.innerHTML;
//       }

//       currentGalleryContainer.innerHTML = newGallerySection.innerHTML;
//       //T4SThemeSP.reinitProductGridItem();
//       if (currentGalleryContainer) {
//         // currentGalleryContainer.style.transition = "opacity 0.2 ease-in";
//         currentGalleryContainer.style.opacity = "1";
//       }

//       T4SThemeSP.RenderRefresh();
//       history.replaceState(null, "", current_product_url);
//     }
//   });
// }

function renderGallerySectionOnPDP(current_product_url) {
  const section_id = $('section[id*="__main"]').attr("id");
  const section_id_to_fetch = section_id.replace(/^shopify-section-/g, "");
  const url_to_fetch = `${window.location.origin}${current_product_url}?section_id=${section_id_to_fetch}`;

  const gallerySectionId = "#shopify-section-template--img__refresh";
  const color_title_selector = ".t4s-product__title .color_title";

  const currentGalleryContainer = document.querySelector(gallerySectionId);
  const colorTitleContainer = $(color_title_selector);

  if (currentGalleryContainer) {
    currentGalleryContainer.style.transition = "opacity 0.3s ease-out";
    currentGalleryContainer.style.opacity = "0";
  }

  T4SThemeSP.getToFetchSection(null, "text", url_to_fetch).then((html) => {
    if (!html) return;

    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(html, "text/html");
    const newGallerySection = htmlDoc.querySelector(gallerySectionId);
    const newColorSection = htmlDoc.querySelector(color_title_selector);

    if (newColorSection && colorTitleContainer.length > 0) {
      colorTitleContainer.text($(newColorSection).text());
    }

    if (currentGalleryContainer && newGallerySection) {
      currentGalleryContainer.innerHTML = newGallerySection.innerHTML;
      currentGalleryContainer.style.opacity = "1";
    }

    // let $isotope = $('.isotopet4s');
    // if ($isotope.length > 0) {
    //    T4SThemeSP.Isotopet4s.init($isotope);
    // }

    // $("[data-product-featured]").removeClass("initProducts__enabled");
    // T4SThemeSP._initProducts();
    
    T4SThemeSP.RenderRefresh();
    history.replaceState(null, "", current_product_url);
  });
}

$(document).on("modalt4s:opened", function () {
  renderProductImageOnQuickShopModal();
  replaceJsonOptionsOnPDP();
  hideShowPromotionMessageWhenSwapBetweenColors();
});

function renderProductImageOnQuickShopModal() {
  const swatchSelector =
    "#t4s-product-quick-view [data-id='0'] [data-swatch-item]";

  $("body")
    .off("click", swatchSelector)
    .on("click", swatchSelector, function () {
      const swatchAutoSelected = $(this);
      const product_url = $(this).data("product-url");

      clearanceDisclaimerForQuickView(swatchAutoSelected);
      getProductToActivateBackInStock(this, product_url);
      NewSwatchBenhaviorForSizeClick();
      hideShowPromotionMessageWhenSwapBetweenColors();
    });

  const initialSwatchClicked = collection_swatch_selected_on_hover
    ? `${swatchSelector}.${collection_swatch_selected_on_hover}`
    : `${swatchSelector}.is--selected`;

  $(initialSwatchClicked).trigger("click");
  collection_swatch_selected_on_hover = null;
}

async function getProductToActivateBackInStock(swatch_clicked, product_url) {
  let handle = product_url.split("?")[0];

  try {
    const response = await fetch(`${handle}.js`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const current_product_back_in_stock = await response.json();

    const productFormBtnCount = $(".t4s-product-form__buttons").length;
    const productContainerSelector =
      productFormBtnCount > 0
        ? ".BIS_trigger.t4s-product-form__submit"
        : ".BIS_trigger";

    $(productContainerSelector).attr(
      "data-product-data",
      JSON.stringify(current_product_back_in_stock)
    );
  } catch (error) {
    console.error("Error fetching the product:", error);
  }
}

function handleSwatchClickOnQuickShop() {
  const swatchSelector =
    "#t4s-product-quick-view [data-id='0'] [data-swatch-item]";
  const gallery_refresh_selector =
    "#shopify-section-template--quickshop__galery_refresh";

  $(document).on("click", swatchSelector, function () {
    const product_url = $(this).data("product-url");
    const current_html = document.querySelector(gallery_refresh_selector);
    if (current_html) {
      current_html.style.transition = "opacity 0.3s ease-out";
      current_html.style.opacity = "0";
    }
    const fullUrl = `${
      window.location.origin + product_url
    }?section_id=main-qv`;

    T4SThemeSP.getToFetchSection(null, "text", fullUrl).then((html) => {
      if (html) {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const gallerySection = htmlDoc.querySelector(gallery_refresh_selector);
        if (current_html && gallerySection) {
          current_html.innerHTML = gallerySection.innerHTML;
          current_html.style.transition = "opacity 0.3s ease-in";
          current_html.style.opacity = "1";
        }
        T4SThemeSP.RenderRefresh();
      }
    });
  });
}

async function fetchAndAttachSection(url, section_id) {
  try {
    let response = await fetch(url);
    if (!response.ok) {
      //console.log("error on response");
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    let responseText = await response.text();
    let htmlToAttach = new DOMParser()
      .parseFromString(responseText, "text/html")
      .querySelector(`#${section_id}`).innerHTML;

    // Add htmlToAttach to the current DOM Element
    return htmlToAttach;
  } catch (error) {
    console.error("Error fetching and attaching section:", error);
  }
}

// function overrideSwatchUrlMissing() {
//   const swatchOptions = $(".is-t4s-style__color .t4s-swatch__item");

//   swatchOptions.each(function () {
//     let product_url = $(this).data("product-url");
//     let product_id = $(this).data("option-value-id");
//     let product_title = $(this).attr("title");

//     if (!product_id || !product_url) {
//       var option_selected = getOptionFromSelectElementHtml(product_title);
//       $(this).data("option-value-id", option_selected.attr("value"));
//       $(this).data("product-url", option_selected.data("variant-url"));
//     }
//   });
// }

let collection_swatch_selected_on_hover = null;
function displaySecondImageOnHoverOnCollectionPage() {
  var swatchSelector = ".t4s-pr-color__item[data-tooltip='top']";
  var eventToExecute = window.innerWidth <= 768 ? "click" : "mouseenter";
  $(document).on(eventToExecute, swatchSelector, function () {
    var index = $(this).index();

    // collection_swatch_selected_on_hover global variable to be use inside the method renderProductImageOnQuickShopModal
    //to select on quick view the right color image when the draw menu is open
    collection_swatch_selected_on_hover = $(this)
      .find('span[class*="bg_color"]')
      .first()
      .attr("class")
      ?.split(" ")
      .find((className) => className.startsWith("bg_color"));

    var productContainer = $(this).closest(".t4s-product-wrapper");

    var data_second_img = $(productContainer).attr("data-second-img");
    var imageUrlArray = data_second_img.split(",");

    var data_product_url_attr = $(productContainer).attr("data-product-url");
    var data_product_url_list = data_product_url_attr.split(",");

    var data_scv_price_attr = $(productContainer).attr("data-scv-price");
    var data_scv_price_list = data_scv_price_attr.split(", ");

    var data_compare_at_price_attr = $(productContainer).attr(
      "data-compare-at-price"
    );
    var data_compare_at_price_list = data_compare_at_price_attr.split(", ");

    productContainer
      .find(".t4s-product-hover-img")
      .attr("src", imageUrlArray[index]);

    productContainer
      .find("[data-pr-href]")
      .attr("href", data_product_url_list[index]);

    getSizeOnCollectionSwatchHover(this, data_product_url_list[index]);

    // productContainer
    //   .find(".t4s-product-btns a")
    //   .attr("href", data_product_url_list[index]);

    var current_price = data_scv_price_list[index];
    current_price = parseFloat(current_price);
    current_price_formatted = T4SThemeSP.Currency.formatMoney(current_price);

    var compare_at_price = data_compare_at_price_list[index];
    compare_at_price = parseFloat(compare_at_price);
    compare_at_price_formatted =
      T4SThemeSP.Currency.formatMoney(compare_at_price);

    var element_price_selector = productContainer.find(".t4s-product-price");

    if (T4Sconfigs.use_sale_badge) {
      calculatePercentageSaved(
        compare_at_price,
        current_price,
        productContainer
      );
    }

    if (current_price != compare_at_price) {
      var html = `<del>
        ${compare_at_price_formatted}
        </del>
        <ins class="custom-prod-on-sale">
        ${current_price_formatted}
        </ins>`;

      element_price_selector.html(html);
    } else {
      element_price_selector.text(compare_at_price_formatted);
    }
  });
}

function customFormatPrice(current_price, compare_at_price) {
  const current_price_formatted =
    T4SThemeSP.Currency.formatMoney(current_price);
  const compare_at_price_formatted =
    T4SThemeSP.Currency.formatMoney(compare_at_price);

  if (current_price != compare_at_price) {
    var html = `<ins class="custom-prod-on-sale">
      ${current_price_formatted}
      </ins><del>
      ${compare_at_price_formatted}
      </del>
      `;

    return html;
  } else {
    return `${compare_at_price_formatted}`;
  }
}

function calculatePercentageSaved(compareAtPrice, currentPrice, $container) {
  const $badgeContainer = $container.find("[data-product-badge]");
  if (!$badgeContainer.length) return;

  if (!compareAtPrice || compareAtPrice <= currentPrice) {
    $badgeContainer.find("[data-badge-sale]").hide();
    return;
  }

  const percentage = Math.round(
    ((compareAtPrice - currentPrice) * 100) / compareAtPrice
  );
  const $badgeElement = $badgeContainer.find("[data-badge-sale]");

  if ($badgeElement.length) {
    $badgeElement.text(`${percentage}% OFF`).show();
  } else {
    $badgeContainer.append(
      $("<span>", {
        "data-badge-sale": "",
        class: "t4s-badge-item t4s-badge-sale",
        text: `${percentage}% OFF`,
      })
    );
  }
}

async function getSizeOnCollectionSwatchHover(swatch_clicked, product_url) {
  let handle = product_url.split("?")[0];
  let size_to_replace = "";
  try {
    const response = await fetch(`${handle}.js`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const current_product_sizes = await response.json();

    current_product_sizes.variants.map((variant) => {
      const isSoldOutUrl = variant.available ? product_url : "#";

      const isSoldOut_BackInStock = variant.available
        ? "t4s-pr-item-btn t4s-pr-addtocart"
        : "BIS_trigger t4s-pr-item-btn t4s-pr-addtocart t4s-product-sizes--sold-out";

      const data_product_data = !variant.available
        ? `data-product-data="${JSON.stringify(current_product_sizes).replace(
            /"/g,
            "&quot;"
          )}"`
        : "";

      const data_action_atc = variant.available
        ? "data-action-atc rel='nofallow'"
        : "";

      const span_size = variant.available
        ? `<span class="t4s-text-pr">${variant.option2}</span>`
        : variant.option2;

      size_to_replace += `
      <a 
        href = "${isSoldOutUrl}" 
        class='${isSoldOut_BackInStock}'  
        ${data_product_data}
        data-variant-id="${variant.id}" ${data_action_atc}>
        ${span_size}
      </a>`;
    });

    var productContainer = $(swatch_clicked).closest(".t4s-product-wrapper");
    productContainer
      .find(".custom-product-sizes .t4s-truncate")
      .html(size_to_replace);
  } catch (error) {
    console.error("Error fetching the product:", error);
  }
}

// Show More functionality for PDP description
function showMore() {
  var $pdpDesContainer = $("#custom_description_container");
  var $toggleDescBtn = $("#toggle-view-description-btn");
  $toggleDescBtn.click(function () {
    $pdpDesContainer.toggleClass("expander");
    $(this).text(
      $pdpDesContainer.hasClass("expander") ? "View Less -" : "View More +"
    );
  });
}

// Custom JS to change and display currently selected variant name under the product image on the collection page on Hover and Click
function updateVariantNameOnCollectionPageOnSwatchClickHover() {
  var swatchSelector = ".t4s-pr-color__item[data-tooltip='top']";
  var eventToExecute = window.innerWidth <= 768 ? "click" : "mouseenter";

  $(document).on(eventToExecute, swatchSelector, function () {
    var newColorSelection = $(this).find(".t4s-pr-color__name").text();
    var productContainer = $(this).closest(".t4s-product");
    productContainer.find(".current-variant-selected").text(newColorSelection);
    productContainer.find(".color_title").text(newColorSelection);
  });
}

// Custom JS to be ordered in the same way that the admin side is the swatch to get the right behavior
function replaceJsonOptionsOnPDP() {
  let baseSelector = getBaseSelector();
  var arrayColorOrder = [];
  var newVariantsObjOrdered = [];

  var swatchColorOptionsItemSelector = $(
    `${baseSelector} [data-id='0'] [data-swatch-item]`
  );

  var jsonVariantsSelector = $(`${baseSelector} .pr_variants_json`);
  var jsonOptionSelector = $(`${baseSelector} .pr_options_json`);

  if (jsonVariantsSelector.length > 0 && jsonOptionSelector.length > 0) {
    var jsonVariantsObj = JSON.parse(jsonVariantsSelector.html());
    var jsonOptionsObj = JSON.parse(jsonOptionSelector.html());

    jsonOptionsObj[0].values = [];

    swatchColorOptionsItemSelector.each(function () {
      var color = $(this).attr("title");
      jsonOptionsObj[0].values.push(color);
      var swatchGroupedByColor = jsonVariantsObj.filter(function (item) {
        return item.option1 == color;
      });
      newVariantsObjOrdered.push(...swatchGroupedByColor);
    });

    var newVariantJsonObj = JSON.stringify(newVariantsObjOrdered);
    var newOptionsObj = JSON.stringify(jsonOptionsObj);

    jsonVariantsSelector.text(newVariantJsonObj);
    jsonOptionSelector.text(newOptionsObj);
  }
}

// Hide or Show the Clearance message on PDP
function clearanceDisclaimer() {
  var clearanceSelector = $(
    ".is-t4s-name__color .t4s-swatch__list .t4s-swatch__item"
  );
  var clearanceMessage = $("#clearance-disclaimer");

  // Initial check on page load with a timeout
  setTimeout(function () {
    var initialSelected = clearanceSelector
      .filter(".is--selected")
      .toArray()
      .some(function (swatch) {
        return (
          $(swatch).attr("data-price-type") === "Clearance" &&
          !$(swatch).hasClass("is--soldout")
        );
      });
    clearanceMessage.toggle(initialSelected);
  }, 500);

  // Event listener for swatch clicks
  clearanceSelector.on("click", function () {
    var priceTypeValue = $(this).attr("data-price-type");
    var isClearance =
      priceTypeValue === "Clearance" && !$(this).hasClass("is--soldout");
    clearanceMessage.toggle(isClearance);
  });
}

function clearanceDisclaimerForQuickView(swatchSelected) {
  var clearanceMessage = $("#clearance-disclaimer");

  var priceTypeValue = $(swatchSelected).attr("data-price-type");
  if (priceTypeValue === "Clearance" && !$(this).hasClass("is--soldout")) {
    clearanceMessage.show();
  } else {
    clearanceMessage.hide();
  }
}

// Hide Gift card data elements in checkout
const checkoutDataElements = document.querySelectorAll(
  ".ecom-cart__product-product-option"
);

// Loop through each element
checkoutDataElements.forEach((element) => {
  // Check if the inner text of the element includes '__shopify_send_gift_card_to_recipient:' or '__shopify_offset:'
  if (
    element.innerText.includes("__shopify_send_gift_card_to_recipient:") ||
    element.innerText.includes("__shopify_offset:") ||
    element.innerText.includes("Send on:")
  ) {
    // Hide the element
    element.style.display = "none";
  }
});

// Container where the popUp will be inserted
const targetNode = document.body;

// Observer configuration
// const config = { childList: true, subtree: true, attributes: true };

// // Callback function for the observer
// const callback = function (mutationsList, observer) {
//   // Disconnect the observer before making changes to avoid infinite loops
//   observer.disconnect();

//   for (let mutation of mutationsList) {
//     if (mutation.type === "childList") {
//       // Get the PopUp Selector when added to the DOM
//       const popup = document.querySelector("#tdf_quickview");
//       if (popup) {
//         const h3Element = document.querySelector(".tdf_qv_h3");
//         if (h3Element) {
//           h3Element.innerHTML = "<strong>Select a free gift!!!</strong>";
//         }
//       }

//       const popupQuickShop = document.querySelector(
//         ".t4s-modal.t4s-modal--is-active"
//       );
//       if (popupQuickShop && !popupQuickShop.dataset.processed) {
//         popupQuickShop.dataset.processed = true;
//         const quickShopView = document.querySelector("#t4s-product-quick-view");
//         const quickShop = document.querySelector("#t4s-product-quick-shop");
//         if (quickShopView || quickShop) {
//           setTimeout(() => {
//             renderProductImageOnQuickShopModal();
//             // clearanceDisclaimerForQuickView();
//           }, 100);
//         }
//       }
//     }
//   }

//   // Reconnect the observer after changes
//   observer.observe(targetNode, config);
// };

// // Create the MutationObserver instance
// const observer = new MutationObserver(callback);

// // Initialize the observer
// observer.observe(targetNode, config);

/* Code for Catalog Request */
function FixCatalogsAddedToDwawerCart() {
  const addCatalogBtn = $(".ecom-product-single__add-to-cart--submit");
  const current_page = window.location.href;
  if (
    current_page.includes("view-online-catalogs") ||
    current_page.includes("request-medpro-kit")
  ) {
    addCatalogBtn
      .map(function (index, item) {
        let productId = $(item).attr("data-variant-id");
        fetchCart(productId, "load");
      })
      .get();
  }
}

async function fetchCart(productId, event) {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const cart = await response.json();
    cart.items.map(function (item) {
      if (productId == String(item.id)) {
        $(
          `.ecom-product-single__add-to-cart--submit[data-variant-id='${item.id}']`
        ).css("display", "none");
        setTimeout(refreshCart(), 1500);
      }
    });
  } catch (error) {
    console.error("Error fetching the cart:", error);
  }
}

function refreshCart() {
  T4SThemeSP.Drawer.opend(jQuery("#t4s-mini_cart"));
}

function deleteCatalogFromMiniCart() {
  const removeBMiniCartBtn = "a.t4s-mini_cart__remove";
  const decreaseQtyMiniCartBtn =
    "button[data-quantity-selector][data-decrease-qty]";
  const combinedSelector = `${removeBMiniCartBtn}, ${decreaseQtyMiniCartBtn}`;

  const current_page = window.location.href;
  if (
    current_page.includes("view-online-catalogs") ||
    current_page.includes("request-medpro-kit")
  ) {
    jQuery(document).on("click", combinedSelector, function (event) {
      const current_page = window.location.href;

      if (
        current_page.includes("view-online-catalogs") ||
        current_page.includes("request-medpro-kit")
      ) {
        const cartItemClass = $(this)
          .closest("[data-cart-item]")
          .attr("class")
          .split(" ")
          .find((cls) => cls.startsWith("cart_item_"));

        const currentItemValue = cartItemClass
          ? cartItemClass.split("_").at(-1)
          : null;

        if (currentItemValue) {
          $(
            `.ecom-product-single__add-to-cart--submit[data-variant-id='${currentItemValue}']`
          ).css("display", "");
        }
        setTimeout(FixCatalogsAddedToDwawerCart, 2500);
      }
    });
  }
}
/* End catalog Request Code */

//  SEO Description on collections
function toggleDescription(blockId) {
  var seoDescription = document.getElementById("accordian-seo-description");

  // Check if the description is already expanded or collapsed
  if (
    seoDescription.style.maxHeight === "0px" ||
    seoDescription.style.maxHeight === ""
  ) {
    // If collapsed, set max-height to a large value to reveal the content
    seoDescription.style.maxHeight = seoDescription.scrollHeight + "px"; // scrollHeight gives the natural height of the content
  } else {
    // If expanded, collapse the description by setting max-height to 0
    seoDescription.style.maxHeight = "0";
  }
}

//Hide Swatch on Markdown

function HideSwatchOnMarkdownOnRegularParent() {
  const swatchMarkdownSelectorToHide = $(".markdown.t4s-swatch__item");
  const markdownContainer = $(".markdown-price-container");

  if (!markdownContainer.data("click-bound")) {
    markdownContainer.on("click", function () {
      swatchMarkdownSelectorToHide.toggleClass(
        "hide-markdown-on-regular-parent"
      );
      $(this).find(".arrow-icon").toggleClass("open");
    });
    markdownContainer.data("click-bound", true);
  }

  if (markdownContainer.hasClass("regular-parent")) {
    if (swatchMarkdownSelectorToHide.hasClass("is--selected")) {
      swatchMarkdownSelectorToHide.removeClass(
        "hide-markdown-on-regular-parent"
      );
      markdownContainer.find(".arrow-icon").addClass("open");
    } else {
      swatchMarkdownSelectorToHide.addClass("hide-markdown-on-regular-parent");
      markdownContainer.find(".arrow-icon").removeClass("open");
    }
  }
}

// Hide color names in titles for Ecomposer pages

document
  .querySelectorAll(".ecom-collection__product-item-information-title")
  .forEach((ecomposerTitle) => {
    const originalText = ecomposerTitle.textContent;
    const newText = originalText.split("|")[0].trim();
    ecomposerTitle.textContent = newText;
  });

// function promoMessage() {
//   var swatchOnPromo = $(
//     ".is-t4s-name__color .t4s-swatch__list .t4s-swatch__item"
//   );
//   var promoMessageBlock = $(".flashy-promo-message");

//   // Initial check on page load with a timeout
//   setTimeout(function () {
//     var initialSelected = swatchOnPromo
//       .filter(".is--selected")
//       .toArray()
//       .some(function (swatch) {
//         return (
//           $(swatch).attr("data-promotion") === "isPromoted" &&
//           !$(swatch).hasClass("is--soldout")
//         );
//       });
//     promoMessageBlock.toggle(initialSelected);
//   }, 500);

//   // Event listener for swatch clicks
//   swatchOnPromo.on("click", function () {
//     var dataPromotionValue = $(this).attr("data-promotion");

//     var isPromoted =
//       dataPromotionValue == "isPromoted" && !$(this).hasClass("is--soldout");
//     promoMessageBlock.toggle(isPromoted);
//   });
// }

// function promoMessage() {
//   const promoMessageBlock = $(".flashy-promo-message");
//   const swatchOnPromo =
//     ".is-t4s-name__color .t4s-swatch__list .t4s-swatch__item";

//   function hasPromotedSwatch() {
//     return $(swatchOnPromo).is(
//       '[data-promotion="isPromoted"]:not(.is--soldout).is--selected'
//     );
//   }

//   function togglePromoMessage() {
//     promoMessageBlock.css("display", hasPromotedSwatch() ? "block" : "none");
//   }

//   // Initial check in case a swatch is pre-selected
//   togglePromoMessage();

//   // Update visibility after swatch click
//   $(document).on("click", swatchOnPromo, function () {
//     setTimeout(togglePromoMessage, 0);
//   });
// }

/**
 * Change logo on hover for transparent header
 */
// document.addEventListener("DOMContentLoaded", function () {
//   const wrapper = document.querySelector(".t4s-header__wrapper.t4s-pr.t4s-layout-layout_bottom");
//   const logo = document.getElementById("main-header-logo");

//   const originalSrc = logo.getAttribute("src");
//   const hoverSrc = "https://cdn.shopify.com/s/files/1/0807/2298/5274/files/Coolibar-BK_Icon_Logo_Tagline_2025_1.png?v=1753473252"; // <-- replace this

//   wrapper.addEventListener("mouseenter", function () {
//     logo.setAttribute("src", hoverSrc);
//   });

//   wrapper.addEventListener("mouseleave", function () {
//     logo.setAttribute("src", originalSrc);
//   });
// });
/**
 * End change logo on hover for transparent header
 */

// document.addEventListener('DOMContentLoaded', () => {
//     const overlay = document.querySelector('.t4s-close-overlay');

//     const closeDrawer = (drawer) => {
//       drawer.setAttribute('aria-hidden', 'true');
//       drawer.classList.remove('is--open');
//       overlay?.classList.remove('is--visible');
//     };

//     const bindToggleButtons = (drawer) => {
//       const inchBtn = drawer.querySelector('#toggle-inch');
//       const cmBtn = drawer.querySelector('#toggle-cm');
//       const inchImg = drawer.querySelector('#size-chart-inch');
//       const cmImg = drawer.querySelector('#size-chart-cm');

//       if (inchBtn?.dataset.bound) return; // Prevent rebinding
//       if (!inchBtn || !cmBtn || !inchImg || !cmImg) return;

//       inchBtn.dataset.bound = "true";

//       const toggle = (unit) => {
//         const isInch = unit === 'inch';
//         inchImg.style.display = isInch ? 'block' : 'none';
//         cmImg.style.display = isInch ? 'none' : 'block';
//         inchBtn.classList.toggle('active', isInch);
//         cmBtn.classList.toggle('active', !isInch);
//       };

//       inchBtn.addEventListener('click', () => toggle('inch'));
//       cmBtn.addEventListener('click', () => toggle('cm'));
//     };

//     document.querySelectorAll('[data-drawer-target]').forEach(button => {
//       const drawerId = button.getAttribute('data-drawer-target');
//       const drawer = document.getElementById(drawerId);

//       button.addEventListener('click', () => {
//         drawer?.setAttribute('aria-hidden', 'false');
//         drawer?.classList.add('is--open');
//         overlay?.classList.add('is--visible');

//         // Slight delay to ensure drawer DOM is available
//         //setTimeout(() => bindToggleButtons(drawer), 50);
//       });

//       drawer?.querySelector('[data-drawer-close]')?.addEventListener('click', () => closeDrawer(drawer));
//     });

//     overlay?.addEventListener('click', () => {
//       document.querySelectorAll('.is--open').forEach(closeDrawer);
//     });
// });

// $(function () {
//   const $descriptionDrawer = $("#customDescriptionDrawer");
//   const $sizeDrawer = $("#customSizeDrawer");
//   const $stickyContainer = $(".t4s-product__info-container--sticky");

//   const updateZIndex = () => {
//     const isOpenDescription =
//       $descriptionDrawer.attr("aria-hidden") === "false";
//     const isOpenSize = $sizeDrawer.attr("aria-hidden") === "false";

//     $stickyContainer.css("z-index", isOpenDescription || isOpenSize ? 500 : 2);
//   };

//   // Solo actualizamos cuando haya clicks en los drawers o botones relacionados
//   $descriptionDrawer
//     .add($sizeDrawer)
//     .add("[data-drawer-target], .t4s-close-overlay")
//     .on("click", updateZIndex);

//   // Opcional: también actualizar al cargar la página
//   updateZIndex();
// });

function modalOpen() {
  return $("html").hasClass("t4s-modal-opened") ? true : false;
}

function getDataFromSwatchSelected() {
  let baseSelector = getBaseSelector();

  const colorSelected = $(
    `${baseSelector}[data-swatch-option][data-id="0"] .is--selected`
  ).data("value");

  const jsonVariants = $(`${baseSelector} .pr_variants_json`);
  if (!jsonVariants.length) return {};

  const jsonVariantsObj = JSON.parse(jsonVariants.html());

  const itemSelected = jsonVariantsObj.find(
    (item) => item.option1 == colorSelected
  );

  const dataToUpdateStickyCart = {
    option1: itemSelected.option1,
    price: itemSelected.price,
    compare_at_price: itemSelected.compare_at_price,
    name: itemSelected.name.split("|")[0].trim(),
    featured_image: itemSelected.featured_image.src,
  };

  return dataToUpdateStickyCart;
}

$(document).on("click", '[data-id="0"] [data-swatch-item]', function () {
    if (modalOpen()) return;
  const swatchData = getDataFromSwatchSelected();
  $(document).trigger("customSwatch:click", swatchData);
});

$(document).on("customSwatch:click", function (evt, data) {
  if (modalOpen()) return;

  $(".t4s-sticky-atc__title").text(data.name.concat(" | ", data.option1));
  let html = customFormatPrice(data.price, data.compare_at_price);
  $(".t4s-sticky-atc__price").html(html);

  $(".t4s-sticky-atc__img.t4s-pr img").attr(
    "data-src",
    T4SThemeSP.Images.lazyloadImagePath(data.featured_image)
  );
});

$(document).on("change:drop", function (event, e, i) {
  let swatchSelected = $(`[data-swatch-option][data-id="0"] .is--selected`);
  swatchSelected.trigger("click");
});

// Render alternate footer message if the user is already subscribed
(function () {
  const maestraDone = localStorage.getItem("popmechanic.completed") !== null;
  const maestraWrapper = document.getElementById('add-maestra-form');

  if (maestraDone && maestraWrapper.children.length === 0) {
    const titleSub = document.createElement('h3');
    titleSub.textContent = 'You’re already subscribed';

    const descriptionsSub = document.createElement('p');
    descriptionsSub.textContent = 'Thanks for being part of the Coolibar community. Stay tuned for exclusive offers, new arrivals, and the latest in UPF 50+ sun protection.';

    const btnWrapperSub = document.createElement('span');
    btnWrapperSub.style.cssText = 'display:flex; gap: 16px;justify-content: center;'
    
    const btnWomen = document.createElement('a');
    btnWomen.href = '/collections/women';
    btnWomen.textContent = 'Shop Women';
    btnWrapperSub.appendChild(btnWomen);

    const btnMen = document.createElement('a');
    btnMen.href = '/collections/men';
    btnMen.textContent = 'Shop Men';
    btnWrapperSub.appendChild(btnMen);

    maestraWrapper.appendChild(titleSub);
    maestraWrapper.appendChild(descriptionsSub);
    maestraWrapper.appendChild(btnWrapperSub);
  }
})();